/** sessionStorage key: public calculator embed (iframe) hint for API auth handling. */
export const PUBLIC_CALCULATOR_EMBED_KEY = 'publicCalculatorEmbed';

/** Fallback when sessionStorage is blocked in embedded webviews. */
let publicCalculatorEmbedMemory = false;

export function setPublicCalculatorEmbedActive(active) {
  publicCalculatorEmbedMemory = !!active;
}

/** True while the public calculator embed route is mounted. */
export function isPublicCalculatorEmbedFromPage() {
  if (publicCalculatorEmbedMemory) return true;
  if (typeof sessionStorage === 'undefined') return false;
  try {
    return sessionStorage.getItem(PUBLIC_CALCULATOR_EMBED_KEY) === '1';
  } catch {
    return false;
  }
}

/**
 * Public SPA routes that must never trigger apiRequest -> /login on 401.
 * - /tools and /tools/*
 * - /:lang/tools/calculator for localized public calculator embeds
 */
export function isPublicToolsSpaPathname(pathname) {
  if (!pathname || typeof pathname !== 'string') return false;
  const normalizedPath = pathname.replace(/\/$/, '') || '/';
  if (normalizedPath === '/tools' || normalizedPath.startsWith('/tools/')) return true;
  return /^\/[a-z]{2}\/tools\/calculator(\/.*)?$/i.test(pathname);
}

export function shouldSkipLoginRedirectForCalculator401() {
  if (isPublicCalculatorEmbedFromPage()) return true;
  if (typeof window === 'undefined') return false;
  return isPublicToolsSpaPathname(window.location.pathname || '');
}

/** @deprecated use isPublicToolsSpaPathname */
export function isPublicCalculatorPathname(pathname) {
  return isPublicToolsSpaPathname(pathname);
}

/** Snapshot for debugging unexpected public calculator login redirects. */
export function getAuth401DebugInfo() {
  if (typeof window === 'undefined') {
    return { env: 'no-window' };
  }
  const pathname = window.location.pathname || '';
  let sessionVal = null;
  try {
    sessionVal =
      typeof sessionStorage !== 'undefined'
        ? sessionStorage.getItem(PUBLIC_CALCULATOR_EMBED_KEY)
        : 'no-sessionStorage';
  } catch (error) {
    sessionVal = `sessionStorage error: ${error?.message || error}`;
  }
  return {
    href: window.location.href,
    pathname,
    embedMemoryFlag: publicCalculatorEmbedMemory,
    embedSessionKey: sessionVal,
    isPublicToolsSpaPathname: isPublicToolsSpaPathname(pathname),
    shouldSkipLoginRedirect: shouldSkipLoginRedirectForCalculator401(),
  };
}

export function isApi401DebugEnabled() {
  try {
    if (typeof window === 'undefined') return false;
    if (window.__BIDMANAGER_API_DEBUG__ === true) return true;
    if (window.__AUTOBUY_API_DEBUG__ === true) return true;
    return new URLSearchParams(window.location.search).get('apiDebug') === '1';
  } catch {
    return false;
  }
}
